import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const taxesJourneyRoutes = [
  {
    id: 'view-taxes-hub',
    trackingName: 'View Taxes Hub',
    path: 'dl/view/taxes/hub',
    loader: async ({ context }) => {
      context?.browserNavigate('/taxes')
    },
  },
] as const satisfies JourneyRoute[]
